import DocumentRequirement from '../DocumentRequirement';
import { TGetProductOffersResponseData } from '../TradingHistory';

type TProps = {
    isOptional: boolean;
    isSubmitted: boolean;
    status?: TGetProductOffersResponseData['products'][number]['data_requirements'][number]['status'];
};
const ManagementAccounts = ({ isOptional, status }: TProps) => {
    return (
        <DocumentRequirement
            title="Current management accounts"
            documentType="management accounts"
            isOptional={isOptional}
            status={status}
        >
            <p>
                Whatever your business uses to aid forecasting, budgeting or
                spending. Particularly useful if you last filed accounts are
                more than 12 months old.
            </p>
        </DocumentRequirement>
    );
};

// eslint-disable-next-line import/no-default-export
export default ManagementAccounts;
